import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DragContext } from '@hub4b/models/drag-context';
import { Folder } from '@hub4b/models/server/folder';

@Component({
    selector: 'app-dragged-row-preview',
    templateUrl: './dragged-row-preview.component.html',
    styleUrls: ['./dragged-row-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class DraggedRowPreviewComponent {
    @Input()
    public draggedElementsCount: number;

    @Input()
    public dragContext: DragContext<Folder>;

    constructor() {}
}
